// extracted by mini-css-extract-plugin
module.exports = {"Tag":"Tag_Tag__dXtt8","isGray":"Tag_isGray__25DJC"};